import { dynamic } from 'next';

const FileExporter = dynamic(() =>
  import('./FileExporterContent')
);

export default FileExporter